import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { CompanyMenuService } from '@app/modules/company/services';
import { NotifyService } from '@app/services';
import {
    CalendarFeedDescriptionDisplayOptions,
    CalendarFeedDisplayOptions,
} from '@app/types/translatables/calendar-feed-display.options';
import { Feed } from '@company/interfaces/feed.interface';
import { CalendarFeed } from '@models/time-off-v3/calendar-feed.model';

@Component({
    templateUrl: './calendar-feed-index.template.html',
    styleUrls: ['./calendar-feed-index.style.scss'],
})
export class CalendarFeedIndexView implements OnInit {
    isLoading = true;
    feeds: Feed[] = [];

    calendarFeedDisplayOptions = CalendarFeedDisplayOptions;
    calendarFeedDescriptionDisplayOptions = CalendarFeedDescriptionDisplayOptions;

    constructor(
        private sanitizer: DomSanitizer,
        private notify: NotifyService,
        public companyMenuService: CompanyMenuService
    ) {}

    async ngOnInit(): Promise<void> {
        await this.loadFeeds();
    }

    async loadFeeds(): Promise<void> {
        this.isLoading = true;

        try {
            this.feeds = (await CalendarFeed.all())[0];
        } catch (err) {
            this.notify.error(err.message || 'company.calendar-feeds.unableToRetrieveFeedsErrorMessage');
        }

        this.isLoading = false;
    }

    sanitize(url: string): SafeUrl {
        return this.sanitizer.bypassSecurityTrustUrl(url);
    }
}
